import React, { useState } from 'react';
import { ThemeProvider } from '@paypalcorp/pp-react';
import HeadlessAuth from '../HeadlessAuth';
import WebLLS from './WebLLS';
import PublicCredential from './PublicCredential';
import Password from './Password';
import Signup from './Signup';
import SendOtp from './SendOtp';
import OtpCode from './OtpCode';
import BackToMerchant from './BackToMerchant';
import TryAnotherWay from './TryAnotherWay';
import PayPalLogo from './PayPalLogo';
import PayPalLogoWithCart from './PayPalLogoWithCart';
import CollectPublicCredential from './CollectPublicCredential';
import GenericError from './GenericError';
import CountrySelector from '../common/CountrySelector';
import Footer from '../common/Footer';
import { PUBLIC_CREDENTIAL, PASSWORD, SEND_OTP, OTP_CODE, GENERIC_ERROR } from '../common/views';
import { COLLECT_PUBLIC_CREDENTIAL } from './views';
import './style.css';
export default function ({ context = '', onAuthEvent, options = {} }) {
    // Introduce additional state that is only required in this flavor
    const [showTryAnotherWay, setShowTryAnotherWay] = useState(false);
    const [isAaeUser, setIsAaeUser] = useState(false);
    const [applePayButtonSeen, setApplePayButtonSeen] = useState(false);
    const getComponentToLoad = (renderProps) => {
        if (renderProps.isWebLLSUser && options.prompt !== 'login') {
            return React.createElement(WebLLS, Object.assign({}, renderProps));
        }
        switch (renderProps.view) {
            case PASSWORD:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Password, Object.assign({}, renderProps)),
                    React.createElement(Signup, Object.assign({}, renderProps, { emptyPublicCredentialOnClick: true, redirectToOnboardingFlow: true }))));
            case SEND_OTP:
                return (React.createElement(React.Fragment, null,
                    React.createElement(SendOtp, Object.assign({}, renderProps)),
                    renderProps.isCookiedUser && React.createElement(Signup, Object.assign({}, renderProps, { emptyPublicCredentialOnClick: true }))));
            case OTP_CODE:
                return React.createElement(OtpCode, Object.assign({}, renderProps));
            case GENERIC_ERROR:
                return React.createElement(GenericError, Object.assign({}, renderProps));
            case COLLECT_PUBLIC_CREDENTIAL:
                return React.createElement(CollectPublicCredential, Object.assign({}, renderProps));
            case PUBLIC_CREDENTIAL:
            default:
                return (React.createElement(React.Fragment, null,
                    React.createElement(PublicCredential, Object.assign({}, renderProps)),
                    React.createElement(Signup, Object.assign({}, renderProps))));
        }
    };
    return (React.createElement(ThemeProvider, { theme: "v2" },
        React.createElement(HeadlessAuth, { context: context, onAuthEvent: onAuthEvent, options: options, componentName: "XoVipAuth" }, (renderProps) => {
            var _a, _b;
            if (!renderProps.isContentLoaded)
                return '';
            const extendedRenderProps = Object.assign(Object.assign({}, renderProps), { isAaeUser,
                applePayButtonSeen,
                setApplePayButtonSeen,
                setIsAaeUser,
                setShowTryAnotherWay });
            const formattedCurrency = (_b = (_a = renderProps === null || renderProps === void 0 ? void 0 : renderProps.authProviderContext) === null || _a === void 0 ? void 0 : _a.formattedCurrency) !== null && _b !== void 0 ? _b : '';
            const showCartHeader = options.showCartAmount &&
                formattedCurrency &&
                (renderProps.view === PASSWORD || renderProps.view === PUBLIC_CREDENTIAL || renderProps.view === '');
            const payPalLogoHeader = showCartHeader ? (React.createElement(PayPalLogoWithCart, { formattedCurrency: formattedCurrency })) : (React.createElement(PayPalLogo, { isCookiedUser: renderProps.isCookiedUser, view: renderProps.view, isAutoOtp: renderProps.isAutoOtp }));
            return (React.createElement("div", { className: "iwc", id: "iwcContainer" },
                React.createElement("div", { className: "formContainer" },
                    !renderProps.isWebLLSUser && payPalLogoHeader,
                    getComponentToLoad(extendedRenderProps),
                    showTryAnotherWay && React.createElement(TryAnotherWay, Object.assign({}, extendedRenderProps))),
                renderProps.view !== COLLECT_PUBLIC_CREDENTIAL && !renderProps.isWebLLSUser && (React.createElement(React.Fragment, null,
                    React.createElement(BackToMerchant, Object.assign({}, extendedRenderProps)),
                    React.createElement(CountrySelector, Object.assign({}, extendedRenderProps)))),
                React.createElement(Footer, Object.assign({}, extendedRenderProps))));
        })));
}
